import React, { useEffect } from 'react'
import { Modal } from 'antd'
import { TableGeneral } from '../../../components/table/TableGeneral'
import CardDetailProject from '../../../components/Card/CardDetailProject'
import HeaderTag from './components/HeaderTag'
import { FormTag } from './components/FormTag'
import { useTags } from './hooks/useTags'

export const PageTag = () => {

    const {
        openModal,
        isEdit,
        columns,
        loading,
        table,
        formData,
        loadingForm,
        searchValue,
        getTags,
        handleOpenModal,
        handleOnCancel,
        handleChangeSearch,
        onFinish
    } = useTags()


    useEffect(() => {
        getTags()
    }, [getTags])

    return (
        <div className="lg:p-12 p-4 w-full h-full flex flex-col gap-6">
            <CardDetailProject
                title="Etiquetas"
                headerChildren={
                    <HeaderTag
                        handleOpenModalCreate={() => handleOpenModal()}
                        searchValue={searchValue}
                        handleChangeSearch={handleChangeSearch}
                    />
                }
            >
                <div className="w-full max-w-[480px] flex justify-center mx-auto">
                    <TableGeneral
                        column={columns}
                        loading={loading}
                        state={table}
                        pagination={{
                            position: ["none", "none"],
                            pageSize: table.length,
                        }}
                        tableProps={{
                            size: "large",
                            bordered: true,
                            className: "cmsTable",
                        }}
                    />
                </div>
            </CardDetailProject>
            <Modal
                title={`${!isEdit ? "Crear Etiquetas" : "Editar Etiquetas"}`}
                width={400}
                onCancel={handleOnCancel}
                open={openModal}
                footer={[]}
            >
                <FormTag
                    loading={loadingForm}
                    onFinish={onFinish}
                    formData={formData}
                />
            </Modal>
        </div>
    )
}
